import { default as login_with_tokenNbvJ1X1FB5Meta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/auth/login_with_token.vue?macro=true";
import { default as loginSCEZt8S0uOMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/auth/login.vue?macro=true";
import { default as indexZuchbcUpDEMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/board/index.vue?macro=true";
import { default as _91id_93y4xgAV7HMkMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/bundles/[id].vue?macro=true";
import { default as indexqeYCrrWVtgMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/bundles/index.vue?macro=true";
import { default as indexZkBzkOV0QsMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/index.vue?macro=true";
import { default as payment_45canceled98Fxf9hau4Meta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/payment-canceled.vue?macro=true";
import { default as payment_45successcdaq4Waaj4Meta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/payment-success.vue?macro=true";
import { default as bundle_45reviewmIRJ2sPFGRMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/bundle-review.vue?macro=true";
import { default as flashcards_45_91id_93Z5Vc60vCCvMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/flashcards-[id].vue?macro=true";
import { default as _91id_93URIeBRzGKgMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session-openai/[id].vue?macro=true";
import { default as live_45session_45textAEhFyTQ9FYMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session-text.vue?macro=true";
import { default as live_45session_45voicewFGvv3Yy2LMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session-voice.vue?macro=true";
import { default as live_45sessionP8w2MH0MbgMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session.vue?macro=true";
import { default as pool5jjVJVpqAsMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/pool.vue?macro=true";
import { default as reviewiUZdZMA57CMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/review.vue?macro=true";
import { default as starter_45packGtWf127ZfKMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/starter-pack.vue?macro=true";
import { default as _91id_93mMUhPs8uhqMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/sessions/[id].vue?macro=true";
import { default as indexOk2incw3sJMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/sessions/index.vue?macro=true";
import { default as newjOlKMrkNryMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/sessions/new.vue?macro=true";
import { default as billingSJFYYkCp6ZMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/billing.vue?macro=true";
import { default as add3QBPXYgPAlMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/languages/add.vue?macro=true";
import { default as index33JSXt1BLaMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/languages/index.vue?macro=true";
import { default as test5qvvYlrSISMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/languages/test.vue?macro=true";
import { default as preferenceskxyDlYey3WMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/preferences.vue?macro=true";
import { default as profileBTQknXUnOlMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/profile.vue?macro=true";
import { default as subscriptionsEeF183GX6Meta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/subscription.vue?macro=true";
import { default as statistic61dJQywXIlMeta } from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/statistic.vue?macro=true";
export default [
  {
    name: "auth-login_with_token",
    path: "/auth/login_with_token",
    meta: login_with_tokenNbvJ1X1FB5Meta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/auth/login_with_token.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginSCEZt8S0uOMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/auth/login.vue")
  },
  {
    name: "board",
    path: "/board",
    meta: indexZuchbcUpDEMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/board/index.vue")
  },
  {
    name: "bundles-id",
    path: "/bundles/:id()",
    meta: _91id_93y4xgAV7HMkMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/bundles/[id].vue")
  },
  {
    name: "bundles",
    path: "/bundles",
    meta: indexqeYCrrWVtgMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/bundles/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexZkBzkOV0QsMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/index.vue")
  },
  {
    name: "payment-canceled",
    path: "/payment-canceled",
    meta: payment_45canceled98Fxf9hau4Meta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/payment-canceled.vue")
  },
  {
    name: "payment-success",
    path: "/payment-success",
    meta: payment_45successcdaq4Waaj4Meta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/payment-success.vue")
  },
  {
    name: "practice-bundle-review",
    path: "/practice/bundle-review",
    meta: bundle_45reviewmIRJ2sPFGRMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/bundle-review.vue")
  },
  {
    name: "practice-flashcards-id",
    path: "/practice/flashcards-:id()",
    meta: flashcards_45_91id_93Z5Vc60vCCvMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/flashcards-[id].vue")
  },
  {
    name: "practice-live-session-openai-id",
    path: "/practice/live-session-openai/:id()",
    meta: _91id_93URIeBRzGKgMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session-openai/[id].vue")
  },
  {
    name: "practice-live-session-text",
    path: "/practice/live-session-text",
    meta: live_45session_45textAEhFyTQ9FYMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session-text.vue")
  },
  {
    name: "practice-live-session-voice",
    path: "/practice/live-session-voice",
    meta: live_45session_45voicewFGvv3Yy2LMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session-voice.vue")
  },
  {
    name: "practice-live-session",
    path: "/practice/live-session",
    meta: live_45sessionP8w2MH0MbgMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/live-session.vue")
  },
  {
    name: "practice-pool",
    path: "/practice/pool",
    meta: pool5jjVJVpqAsMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/pool.vue")
  },
  {
    name: "practice-review",
    path: "/practice/review",
    meta: reviewiUZdZMA57CMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/review.vue")
  },
  {
    name: "practice-starter-pack",
    path: "/practice/starter-pack",
    meta: starter_45packGtWf127ZfKMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/practice/starter-pack.vue")
  },
  {
    name: "sessions-id",
    path: "/sessions/:id()",
    meta: _91id_93mMUhPs8uhqMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/sessions/[id].vue")
  },
  {
    name: "sessions",
    path: "/sessions",
    meta: indexOk2incw3sJMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/sessions/index.vue")
  },
  {
    name: "sessions-new",
    path: "/sessions/new",
    meta: newjOlKMrkNryMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/sessions/new.vue")
  },
  {
    name: "settings-billing",
    path: "/settings/billing",
    meta: billingSJFYYkCp6ZMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/billing.vue")
  },
  {
    name: "settings-languages-add",
    path: "/settings/languages/add",
    meta: add3QBPXYgPAlMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/languages/add.vue")
  },
  {
    name: "settings-languages",
    path: "/settings/languages",
    meta: index33JSXt1BLaMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/languages/index.vue")
  },
  {
    name: "settings-languages-test",
    path: "/settings/languages/test",
    meta: test5qvvYlrSISMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/languages/test.vue")
  },
  {
    name: "settings-preferences",
    path: "/settings/preferences",
    meta: preferenceskxyDlYey3WMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/preferences.vue")
  },
  {
    name: "settings-profile",
    path: "/settings/profile",
    meta: profileBTQknXUnOlMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/profile.vue")
  },
  {
    name: "settings-subscription",
    path: "/settings/subscription",
    meta: subscriptionsEeF183GX6Meta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/settings/subscription.vue")
  },
  {
    name: "statistic",
    path: "/statistic",
    meta: statistic61dJQywXIlMeta || {},
    component: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/pages/statistic.vue")
  }
]